import axios, { AxiosResponse } from 'axios';
import { MolecularResponse } from 'src/types';
import { getMolecularUrl } from 'src/bff';
import { reportErrorSentry } from 'src/bff';

export const dpsSend = async (formData: FormData): Promise<AxiosResponse<MolecularResponse>> => {
  try {
    const MOLECULAR_URL = getMolecularUrl();
    const response = await axios.post(`${MOLECULAR_URL}/request-dps-send.php`, formData);
    return response;
  } catch (error) {
    reportErrorSentry(error);
    return null;
  }
};
